import Vue from "vue";
export default {
    namespaced: true,
    state: {
        items: [],
        value: null,
    },

    getters: {
        items(state,) {
            return state.items;
        },
    },

    mutations: {
        SET_NULL(state) {
            state.value = null;
        },
        SELECT_AREA(state, item) {
            state.value = item;
        },
        SET_AREAS(state, items = []) {
            state.items = items;
        },
        ADD_AREA(state, oneItem) {
            state.items.push(oneItem);
        },
        DELETE_AREA(state, Id) {
            const ind = state.items.findIndex(area => area.id === Id);
            if (ind !== -1) {
                state.items.splice(ind, 1);
            }
        },

        EDIT_AREA(state, { Id, area }) {
            const ind = state.items.findIndex(area => area.id === Id);

            if (ind !== -1) {
                Vue.set(state.items, ind, area);
            }
        }
    },

    actions: {
        setAreaNull({ commit }) {
            return (commit('SET_NULL'), true)
        },

        selectArea({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item === data);
            return exitsItem ? (commit('SELECT_AREA', data), true) : false;
        },

        // first param is context object
        setAreas({ commit }, data) {
            commit('SET_AREAS', data);
            return true;
        },
        addArea({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === data.id);
            return !exitsItem ? (commit('ADD_AREA', data), true) : false;
        },

        deleteArea({ state, commit }, id) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === id);
            return exitsItem ? (commit('DELETE_AREA', id), true) : false;
        },

        editArea({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === data.id);
            return exitsItem ? (commit('EDIT_AREA', data), true) : false;
        },

    }
};
